import { render } from "./OpenInvoices.vue?vue&type=template&id=1e0ee9a6"
import script from "./OpenInvoices.vue?vue&type=script&lang=js"
export * from "./OpenInvoices.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__